export default "__VITE_ASSET__C8Q2X1r0__"